import IsTokenValid from "@/api/IsTokenValid";
import Loader from "@/components/Loader";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoutes = () => {
	const [isLogedIn, setIsLogedIn] = useState<boolean | null>(null);

	useEffect(() => {
		const checkAuth = async () => {
			const valid = await IsTokenValid();
			setIsLogedIn(valid);
		};
		checkAuth();
	}, []);

	if (isLogedIn === null) {
		return (
			<div className="flex justify-center items-center h-screen">
				<Loader />
			</div>
		);
	}

	return isLogedIn ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
